<template>
    <div>
        <transition-group name="fade" mode="out-in" tag="div" class="posts__section posts__section--works" v-show="!loadingState">
            <div v-cloak
                v-for="(item, index) in catalogItems"
                :key="item.id"
                v-show="!loadingState"
                class="post__content"
                >

                <h2>
                    <div class="flex-minh-c">
                        <span class="heading-icon" :class="{'invert-icon': isNotEdition8Or10(item)}">
                            <img style="height: 30px" v-if="item.icon" :src="'https://www.amsterdamlightfestival.com/storage/' + item.icon">
                            <img v-else src="/site/img/heading-icon.svg">
                        </span>
                        <span>
                            {{ item.title }}
                        </span>
                    </div>

                </h2>

                <a v-if="item.thumbnails && item.thumbnails.length > 1" :href="item.url">
                    <slick
                            class="post__content-thumbnail"
                            ref="slick"
                            :options="{ arrows: true, dots: true, infinite: false }"
                    >
                        <div v-for="thumbnail in item.thumbnails" class="slider-inner" >
                            <img v-if="thumbnail !== null" :src="'https://www.amsterdamlightfestival.com/storage/' + thumbnail" alt="">
                            <img v-else src="/site/img/ALF-thumbnail-artist-landscape.jpg" alt="">
                        </div>
                    </slick><!-- /.post__content-thumbnail -->
                </a>
                <a v-else :href="item.url" class="no-slider">
                    <div class="post__content-thumbnail">
                        <div class="">
                            <img v-if="item.thumbnails && item.thumbnails[0] !== null" :src="'https://www.amsterdamlightfestival.com/storage/' + item.thumbnails[0]" alt="">
                            <img v-else src="/site/img/ALF-thumbnail-artist-landscape.jpg" alt="">
                        </div>
                    </div><!-- /.post__content-thumbnail -->
                </a>


                <div class="post__content-inner2">
                    <p v-if="item.artistName" :title="item.artistName">{{ item.artistName }}<br> <span v-show="showEditionAndCollection"><span v-text="item.editionTitle"></span><span v-show="item.international"> - {{ internationalLabel }}</span></span></p>

                    <!-- <span v-show="activeEdition">{{ artwork.edition.title }}</span> TODO: format using resource object -->
                    <div class="post__content-action">
                        <a :href="item.url" class="post__content-btn artwork">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14.3" ><path d="M14 7.2L6.9 0l-.6.6 6 6.1H0v.9h12.3l-6 6.1.6.6z"/></svg>
                        </a>
                    </div><!-- /.action-section -->
                </div><!-- /.post__content-inner2 -->

            </div><!-- /.post__content -->
        </transition-group>

        <div class="posts__section">

            <transition name="fade" mode="out-in">
                <alf-loader v-show="loadingState"></alf-loader>
            </transition>

        </div><!-- /.posts__section -->
    </div>
</template>

<script>
import Slick from 'vue-slick'
import Loader from './../loader'
const locale = document.getElementsByTagName('html')[0].getAttribute('lang');

export default {

    components: {
        Slick,
        'alf-loader': Loader
    },
    props: {
        catalogItems: { required: true },
        loadingState: { required: true },
        activeEdition:{ required: true },
        collection:{ required: false }
    },
    methods: {
        isNotEdition8Or10: function(item){
            return item.editionTitle !== 'Editie #8' && item.editionTitle !== 'Editie #10' ;
        }
    },
	computed: {
        readMoreLabel: function(){

            if(locale === 'nl') {
                return 'LEES MEER';
            }
            return 'READ MORE';
		},
        internationalLabel: function(){
            if(locale === 'nl') {
                return 'Internationaal';
            }
            return 'International';
        },
        showEditionAndCollection: function(){
            return (this.$route.params.slug == 'international' || this.$route.params.slug == 'all');
        },

	}
}
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.fade-enter-active {
    @for $i from 1 through 30 {
        &:nth-of-type(#{$i}) {
            transition-delay: $i * 0.06s;
        }
    }
}
[v-cloak] {display: none}


.post__content-btn.artwork svg{
    right: 7px;
    top: 6px;
}


</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/catalog-filter/catalog-listing.vue